var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useCallback } from 'react';
import classNames from 'classnames';
import { Badge, Button } from "../../index";
import { useTranslation } from "../../hooks/useTranslation";
import { Search } from "../../icons/index";
import { makeStyles } from "../../styles/index";
var useStyles = makeStyles(function () { return ({
    root: {
        minWidth: 94,
        padding: 0,
    },
}); });
/**
 * 検索ボタンとして使うためのコンポーネント
 */
export var SearchButton = React.forwardRef(function (props, ref) {
    var classesProp = props.classes, classNameProp = props.className, isBadgeVisible = props.isBadgeVisible, label = props.label, onClick = props.onClick, others = __rest(props, ["classes", "className", "isBadgeVisible", "label", "onClick"]);
    var classes = useStyles({ classes: classesProp });
    var rootClassName = classNames(classes.root, classNameProp);
    var handleClick = useCallback(function (event) {
        onClick(event);
    }, [onClick]);
    var t = useTranslation().t;
    return (React.createElement(Button, __assign({ ref: ref, variant: "text", onClick: handleClick, className: rootClassName }, others),
        React.createElement(Search, null),
        React.createElement(Badge, { color: "primary", variant: "dot", invisible: !isBadgeVisible },
            React.createElement("span", null, label || t('検索')))));
});
